import React, { Component } from 'react';
import "./css/Main.css";

import webSocketClient from "./socket/socket";

import Header from "./widget/header";
import Page404 from "./widget/widget.404";
import WidgetLogin from "./widget/widget.login";
import WidgetConnection from "./widget/widget.connection";


import loadable from '@loadable/component'

const PageDashboard         = loadable(() => import('./page/other/dashboard'));
// --------------------------------
// DATA
// --------------------------------
const PageCampaign          = loadable(() => import('./page/data/campaign'));
const PageLeads             = loadable(() => import('./page/data/leads'));
const PageData              = loadable(() => import('./page/data/data'));
// --------------------------------
// DIALER MANAGEMENT
// --------------------------------
const PageCompany           = loadable(() => import('./page/data/company'));
const PageResult            = loadable(() => import('./page/data/result'));
const PageDialer            = loadable(() => import('./page/data/dialer'));
const PageHoliday           = loadable(() => import('./page/data/holiday'));
// --------------------------------
// CALL MANAGEMENT
// --------------------------------
const PageVoiceprompt       = loadable(() => import('./page/asterisk/voiceprompt'));
const PageAGI               = loadable(() => import('./page/asterisk/agi'));
const PageCallRoute         = loadable(() => import('./page/asterisk/call.routes'));
const PageTrunks            = loadable(() => import('./page/asterisk/sip.trunk'));
const PageACD               = loadable(() => import('./page/asterisk/acd'));

const PageIvrMenu           = loadable(() => import('./page/asterisk/ivr.menu'));
const PageIvrResponse       = loadable(() => import('./page/asterisk/ivr.response'));
// --------------------------------
// ACCESS MANAGEMENT
// --------------------------------
const PageAPI               = loadable(() => import('./page/data/api'));
const PageRole              = loadable(() => import('./page/config/cfg.role'));
const PageUsers             = loadable(() => import('./page/config/cfg.user'));
const PageMatrix            = loadable(() => import('./page/config/cfg.matrix'));
// --------------------------------
// SYSTEM MANAGEMENT
// --------------------------------
const PageSystem            = loadable(() => import('./page/config/system'));
const PageInformation       = loadable(() => import('./page/config/system.info'));
const PageModule            = loadable(() => import('./page/config/module.info'));

const PageAutotext          = loadable(() => import('./page/config/autotext'));

// --------------------------------
// SYSTEM MAINTENANCE
// --------------------------------
const PageLogAdmin          = loadable(() => import('./page/system/admin.log'));
const PageLogData           = loadable(() => import('./page/system/call.log'));
// --------------------------------
// REPORT
// --------------------------------
const ReportCallHistory     = loadable(() => import('./page/report/call.history'));
const RptCallResult         = loadable(() => import('./page/report/call.result'));
const RptDataSummary        = loadable(() => import('./page/report/data.summary'));
const RptIvrLog             = loadable(() => import('./page/report/ivr.log'));
// --------------------------------
// OTHER
// --------------------------------
const MyAccount             = loadable(() => import('./page/config/my.account')); 
MyAccount.preload();
PageDashboard.preload();

class Main extends Component {
    constructor(props) {
        super(props);

        this.maxLogged          = 200;

        //this.waktuElapsed       = 0;

        this.state = {
            hostname: window.location.hostname,
            port: this.props.port,
            // hostname: '192.168.99.30',

            socketConnected: false,
            showWidgetSocket: false,

            currPage: '',
            currFilter: {},

            isLoggedIn: false,
            username: '',
            fullname: '',
            level: '',
            debugLogList: [],
            isDebug: false,
            isLogged: false,
            isFullAccess: false,

            maximumConccurent: 0,
            currentConcurrent: 0,
            moduleStatus: false,
            loggerStatus: false,
            debuggerStatus: false,

            counterTotal: 0,
            counterList: [],
            counterListDetail: [],

            accessList: [],
            menuList: [],
            serverTime: "",
            unixTime: 0,
        }
        this.keepAliveTimer                         = null;
        //this.serverTimeTimer                        = null;
        this.socketClient                           = webSocketClient();

        this.handleWidgetSocketClose                = this.handleWidgetSocketClose.bind(this);
        this.handleSocketConnection                 = this.handleSocketConnection.bind(this);
        this.handleReloadPage                       = this.handleReloadPage.bind(this);
        this.reloadWarning                          = this.reloadWarning.bind(this);
        this.handleNavigatePages                    = this.handleNavigatePages.bind(this);

        this.handleClearFilter                      = this.handleClearFilter.bind(this);
        this.handleNewLogger                        = this.handleNewLogger.bind(this);

        this.handleUpdateAccess                     = this.handleUpdateAccess.bind(this);
        this.handlePreloadPage                      = this.handlePreloadPage.bind(this);
        this.handleUpdateLoggedIn                   = this.handleUpdateLoggedIn.bind(this);
        this.handleUpdateLoggedOut                  = this.handleUpdateLoggedOut.bind(this);
    }
// ==================================================================================
// COMPONENT DID MOUNT
// ==================================================================================
    componentDidMount() {
        //this.handleSocketConnection();
        
        this.socketClient.onEvent("UserLoggedIn", (event) => {
            if(!event.hasOwnProperty("username")){
                //console.log('UserLoggedIn', event);
                this.setState({
                    ...this.state,
                    isLoggedIn: true,
                    level: event.level,
                    isFullAccess: event.isFullAccess,
                    currPage: event.company_id === 0?'PageDashboard':'',
                    debugLogList: [],
                    showWidgetSocket: false,
                });

                this.keepAliveTimer = setInterval( () => {
                    this.socketClient.sendAction({
                        action: 'KeepAlive'
                    },() => {});
                }, 60000);

                window.addEventListener("beforeunload", this.reloadWarning);
            } else {
                this.handleNewLogger(event);
            }
        });

        this.socketClient.onEvent("GetMenu", (event) => {
            //console.log('event (GetMenu)', event);
            if (!event.hasOwnProperty("username")) {
                if (event.hasOwnProperty("access") && event.access instanceof Array && event.hasOwnProperty("menu") && event.menu instanceof Array) {
                    this.setState({
                        ...this.state,
                        accessList: event.access,
                        menuList: event.menu,
                        currPage: event.access.indexOf('show-dashboard') > -1? 'PageDashboard':'',
                    });
                }
            }            
        });

        this.socketClient.onEvent("GetMaxConcurrent", (event) => {
            //console.log('GetMaxConcurrent', (event));
            if (!event.hasOwnProperty("username")) {
                if (event.hasOwnProperty("MAXIMUM_CC") && typeof event.MAXIMUM_CC !== 'undefined') {
                    let tmpConcurrent       = 0;
                    switch(typeof event.MAXIMUM_CC) {
                        case 'string':
                            tmpConcurrent   = parseInt(event.MAXIMUM_CC);
                        break;
                        case 'number':
                            tmpConcurrent   = event.MAXIMUM_CC;
                        break;
                        default:
                    }

                    if (tmpConcurrent > 0) {
                        this.setState({
                            ...this.state,
                            maximumConccurent: tmpConcurrent,
                            moduleStatus: event.CONTROLLER_STATUS.trim() === 'Running'? true:false,
                            loggerStatus: event.MODULE_LOGGER === 1?true:false,
                            debuggerStatus: event.MODULE_DEBUGGER === 1?true:false,
                        });
                    }
                }
            }
        });


        this.socketClient.onEvent("UserLoggedOut", (event) => {
            if(!event.hasOwnProperty("username")){
                console.log('UserLoggedOut', this.state);
                clearInterval(this.keepAliveTimer);
                this.keepAliveTimer     = null;
                window.removeEventListener("beforeunload", this.reloadWarning);

                this.setState({
                    ...this.state,
                    level: '',
                    isLoggedIn: false,
                    isFullAccess: false,
                    debugLogList: [],
                    accessList: [],
                    menuList: [],
                });
            } else {
                this.handleNewLogger(event);
            }
        });

        // KETIKA USER LOGGED OUT
        this.socketClient.onDisconnected(() => {
            clearInterval(this.keepAliveTimer);
            this.keepAliveTimer     = null;
            window.removeEventListener("beforeunload", this.reloadWarning);
            
            if (this.state.isLoggedIn) {
                if (this.state.socketConnected) {
                    setTimeout(() => {
                        this.setState({
                            ...this.state,
                            showWidgetSocket: true,
                        });
                    }, 2000);
                }
                this.setState({
                    ...this.state,
                    socketConnected: false,
                    isLoggedIn: false,
                    username: '',
                    fullname: '',
                    level: '',
                    isFullAccess: false,
                    debugLogList: [],
                    accessList: [],
                    menuList: [],
                    currPage: 'PageDashboard',
                    maximumConccurent: 0,
                    currentConcurrent: 0,
                    moduleStatus: false,
                    loggerStatus: false,
                    debuggerStatus: false,
                });

                //this.handleSocketConnection();
                
            } else {
                this.setState({
                    ...this.state,
                    socketConnected: false,
                    isLoggedIn: false,
                    username: '',
                    fullname: '',
                    level: '',
                    isFullAccess: false,
                    debugLogList: [],
                    accessList: [],
                    menuList: [],
                    currPage: 'PageDashboard',
                    maximumConccurent: 0,
                    currentConcurrent: 0,
                    moduleStatus: false,
                    loggerStatus: false,
                    debuggerStatus: false,
                });                
            }
        });
        /*
        this.socketClient.onDisconnected(() => {
            clearInterval(this.keepAliveTimer);
            this.keepAliveTimer     = null;
            window.removeEventListener("beforeunload", this.reloadWarning);
            
            if (this.state.isLoggedIn){
                this.setState({
                    ...this.state,
                    socketConnected: false,
                    isLoggedIn: false,
                    level: '',
                    isFullAccess: false,
                    debugLogList: [],
                    currPage: 'PageDashboard',
                });
                this.handleSocketConnection();
            } else {
                this.setState({
                    ...this.state,
                    socketConnected: false,
                    isLoggedIn: false,
                    level: '',
                    isFullAccess: false,
                    debugLogList: [],
                    currPage: 'PageDashboard',
                });
                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        showWidgetSocket: true,
                    });
                }, 2000);
            }
        });
        */
        // INFORMASI MODULE STATUS
        this.socketClient.onEvent("SetModuleStatus", (event) => {
            if (event.hasOwnProperty("status_new") && typeof event.status_new === 'string' && event.status_new.trim() !== '') {
                this.setState({
                    ...this.state,
                    moduleStatus: event.status_new.trim() === 'Running'? true:false,
                });
            }
        });

        this.socketClient.onEvent("DebuggerSetStatus", (event) => {
            if (event.hasOwnProperty("status") && typeof event.status !== 'undefined') {
                let tmpNewState         = false;
                switch (typeof event.status) {
                    case 'string':
                        if (event.status.trim().toLowerCase() === 'active' || event.status.trim().toLowerCase() === '1') {
                            tmpNewState = true;
                        }
                    break;
                    case 'number':
                        if (event.status === 1) {
                            tmpNewState = true;
                        } 
                    break;
                    default:
                }
                this.setState({
                    ...this.state,
                    debuggerStatus: tmpNewState,
                });
            }
        });

        this.socketClient.onEvent("LoggerSetStatus", (event) => {
            if (event.hasOwnProperty("status") && typeof event.status !== 'undefined') {
                let tmpNewState         = false;
                switch (typeof event.status) {
                    case 'string':
                        if (event.status.trim().toLowerCase() === 'active' || event.status.trim().toLowerCase() === '1') {
                            tmpNewState = true;
                        }
                    break;
                    case 'number':
                        if (event.status === 1) {
                            tmpNewState = true;
                        } 
                    break;
                    default:
                }
                this.setState({
                    ...this.state,
                    loggerStatus: tmpNewState,
                });
            }
        });
    // -------------------------------------------------
    // LOGGER DI DASHBOARD
    // -------------------------------------------------
        this.socketClient.onEvent("VoiceblastCcAdd", (event) => {
            //console.log('(+) VoiceblastCcAdd', event);
            this.handleNewLogger(event);

            let tmpConcurrent   = 0;
            if (parseInt(event.my_companyId) === 0) {
                tmpConcurrent   = parseInt(event.cc_global);
            } else {
                tmpConcurrent   = parseInt(event.cc_company);
            }

            this.setState({
                ...this.state,
                currentConcurrent: tmpConcurrent,
            });
        });
        this.socketClient.onEvent("VoiceblastCcDel", (event) => {
            //console.log('(-) VoiceblastCcDel', event);
            this.handleNewLogger(event);
            let tmpConcurrent   = 0;
            if (parseInt(event.my_companyId) === 0) {
                tmpConcurrent   = parseInt(event.cc_global);
            } else {
                tmpConcurrent   = parseInt(event.cc_company);
            }

            this.setState({
                ...this.state,
                currentConcurrent: tmpConcurrent,
            });
        });

        // -----------------------------------------------
        // <-- MODULE || DASHBOARD --> 
        // -----------------------------------------------
        // PROCESS DIALING
        this.socketClient.onEvent("VoiceblastProcessing", (event) => {
            this.handleNewLogger(event);
        });
        // CDR
        this.socketClient.onEvent("VoiceblastCallHangup", (event) => {
            this.handleNewLogger(event);
        });

        // ASTERISK EVENT
        this.socketClient.onEvent("VoiceblastTransferRinging", (event) => {
            this.handleNewLogger(event);
        });
        this.socketClient.onEvent("VoiceblastTransferTalking", (event) => {
            this.handleNewLogger(event);
        });
        this.socketClient.onEvent("VoiceblastTransferHangup", (event) => {
            this.handleNewLogger(event);
        });

        this.socketClient.onEvent("VoiceblastCallRinging", (event) => {
            this.handleNewLogger(event);
        });
        this.socketClient.onEvent("VoiceblastCallTalking", (event) => {
            this.handleNewLogger(event);
        });

        this.socketClient.onEvent("VoiceblastHangup", (event) => {
            this.handleNewLogger(event);
        });
        this.socketClient.onEvent("VoiceblastCallUserEvent", (event) => {
            this.handleNewLogger(event);
        });
    // -------------------------------------------------
    }
// ==================================================================================
// FUNCTION
// ==================================================================================
    handleNewLogger(event) {
        if (typeof event === 'object' && event.hasOwnProperty("messageid") && typeof event.messageid === 'string' && event.messageid.trim() !== '') {
            let tmpCurrLog      = this.state.debugLogList.slice();
            if (tmpCurrLog.length >= this.maxLogged) {
                tmpCurrLog.shift();
            }
            tmpCurrLog.push(event);

            this.setState({
                ...this.state,
                debugLogList: tmpCurrLog,
            });
        }
    }
    handleWidgetSocketClose(){
        if (this.state.showWidgetSocket){
            this.setState({
                ...this.state,
                showWidgetSocket: false,
            });

            setTimeout(() => {
                if (!this.state.socketConnected){
                    this.setState({
                        ...this.state,
                        showWidgetSocket: true,
                    });
                }
            }, 2500);
        }
    }

    handleSocketConnection(){
        this.socketClient.connectToHost(this.state.hostname, this.state.port, (e) => {
            if (e.type === 'open'){
                this.setState({
                    ...this.state, 
                    socketConnected: true,
                    showWidgetSocket: false,
                });
            } else {
                this.setState({
                    ...this.state,
                    socketConnected: false,
                    showWidgetSocket: true,
                });
            }
        })
    }

    handleReloadPage() {
        window.location.reload();
    }

    reloadWarning(event) {
        if (this.state.isLoggedIn){
            event.returnValue = "JANGAN RELOAD HALAMAN!!\n\nJIKA ANDA MERELOAD HALAMAN INI ANDA AKAN LOGOUT DARI SYSTEM!!";
        } 
    }

    handleNavigatePages(page){
        if (typeof page === 'string' && page.trim() !== ''){
            
            switch(page.toString().trim()){                
                case 'PageLogout':
                    this.socketClient.sendAction({
                        action: 'Logout',
                    },(response) => {
                        this.handleUpdateLoggedOut();
                    });
                break;
                default:
                    this.setState({
                        ...this.state,
                        currPage: `${page.trim()}`,
                    });
            }
        }
    }

    handleClearFilter() {
        this.setState({
            ...this.state,
            currFilter: {}
        });
    }
    handleUpdateAccess(ListAccess) {
        if (ListAccess instanceof Array && ListAccess.length > 0) {
            this.setState({
                ...this.state,
                accessList: ListAccess,
            });
        }
    }

    handlePreloadPage(ListMenu) {
        if (ListMenu instanceof Array && ListMenu.length > 0) {            
            this.setState({
                ...this.state,
                menuList: ListMenu,
            });

            ListMenu.forEach((menuValues) => {
                switch(menuValues.title) {
                // --------------------------------
                    case "Data":
                // --------------------------------
                        let childArray_01   = menuValues.child.slice();
                        childArray_01.forEach((menuDetail) => {
                            switch(menuDetail.page){
                                case "PageCampaign":
                                    PageCampaign.preload();
                                break;
                                case "PageLeads":
                                    PageLeads.preload();
                                break;
                                case "PageData":
                                    PageData.preload();
                                break;
                                default:
                            }
                        });
                // --------------------------------
                    break;
                    case "Report":
                // --------------------------------
                        let childArray_02   = menuValues.child.slice();
                        childArray_02.forEach((menuDetail) => {
                            switch(menuDetail.page){
                                case "RptCallHistory":
                                    ReportCallHistory.preload();
                                break;
                                case "RptCallResult":
                                    RptCallResult.preload();
                                break;
                                case "RptDataSummary":
                                    RptDataSummary.preload();
                                break;
                                case "RptIvrLog":
                                    RptIvrLog.preload();
                                break;
                                default:
                            }
                        });
                // --------------------------------
                    break;
                    case "Dialer Management":
                // --------------------------------
                        let childArray_03   = menuValues.child.slice();
                        childArray_03.forEach((menuDetail) => {
                            switch(menuDetail.page){
                                case "PageCompany":
                                    PageCompany.preload();
                                break;
                                case "PageResult":
                                    PageResult.preload();
                                break;
                                case "PageDialer":
                                    PageDialer.preload();
                                break;
                                case "PageHoliday":
                                    PageHoliday.preload();
                                break;
                                default:
                            }
                        });
                // --------------------------------
                    break;
                    case "Call Management":
                // --------------------------------
                        let childArray_04   = menuValues.child.slice();
                        childArray_04.forEach((menuDetail) => {
                            switch(menuDetail.page){
                                case "PageVoiceprompt":
                                    PageVoiceprompt.preload();
                                break;
                                case "PageAGI":
                                    PageAGI.preload();
                                break;
                                case "PageCallRoute":
                                    PageCallRoute.preload();
                                break;
                                case "PageTrunks":
                                    PageTrunks.preload();
                                break;
                                case "PageQueue":
                                    PageACD.preload();
                                break;
                                case "PageIvrMenu":
                                    PageIvrMenu.preload();
                                break;
                                case "PageIvrResponse":
                                    PageIvrResponse.preload();
                                break;
                                default:
                            }
                        });
                // --------------------------------
                    break;
                    case "Access Management":
                // --------------------------------
                        let childArray_05   = menuValues.child.slice();
                        childArray_05.forEach((menuDetail) => {
                            switch(menuDetail.page){
                                case "PageAPI":
                                    PageAPI.preload();
                                break;
                                case "PageRole":
                                    PageRole.preload();
                                break;
                                case "PageUsers":
                                    PageUsers.preload();
                                break;
                                case "PageMatrix":
                                    PageMatrix.preload();
                                break;
                                default:
                            }
                        });
                // --------------------------------
                    break;
                    case "System Management":
                // --------------------------------
                        let childArray_06   = menuValues.child.slice();
                        childArray_06.forEach((menuDetail) => {
                            switch(menuDetail.page){
                                case "PageInformation":
                                    PageInformation.preload();
                                break;
                                case "PageSystem":
                                    PageSystem.preload();
                                break;
                                case "PageModule":
                                    PageModule.preload();
                                break;
                                case "PageAutotext":
                                    PageAutotext.preload();
                                break;
                                default:
                            }
                        });
                // --------------------------------
                    break;
                    case "System Maintenance":
                // --------------------------------
                        let childArray_07   = menuValues.child.slice();
                        childArray_07.forEach((menuDetail) => {
                            switch(menuDetail.page){
                                case "PageLogAdmin":
                                    PageLogAdmin.preload();
                                break;
                                case "PageLogData":
                                    PageLogData.preload();
                                break;                                
                                default:
                            }
                        });

                // --------------------------------
                    break;
                    default:
                // --------------------------------
                }
            });
        }
    }

    handleUpdateLoggedIn(data) {
        if (typeof data === 'object') {
            if (
                data.hasOwnProperty("isConnected") && typeof data.isConnected === 'boolean' &&
                data.hasOwnProperty("isLoggedIn") && typeof data.isLoggedIn === 'boolean' 
            ) {
                this.setState({
                    ...this.state,
                    socketConnected: data.isConnected,
                    showWidgetSocket: data.isConnected?false:true,
                    isLoggedIn: data.isLoggedIn,
                });
            }
        }
    }

    handleUpdateLoggedOut() {
        this.setState({
            ...this.state,
            isLoggedIn: false,
            level: '',
            isFullAccess: false,
            debugLogList: [],
            accessList: [],
            menuList: [],
            currPage: 'PageDashboard',
            maximumConccurent: 0,
            currentConcurrent: 0,
            moduleStatus: false,
            loggerStatus: false,
            debuggerStatus: false,
            username: '',
            fullname: '',
            isDebug: false,
            isLogged: false,
        });
    }
// ==================================================================================
// RENDER
// ==================================================================================
    render() {
        const Halaman = () => {
            switch(this.state.currPage) {
                case "PageDashboard":
                    return <PageDashboard 
                    isFullAccess={this.state.isFullAccess} isDebug={this.state.isDebug} isLogged={this.state.isLogged} 
                    currentLog={this.state.debugLogList}
                    maxLogged={this.maxLogged}
                    maximumConcurrent={this.state.maximumConccurent} 
                    currentConcurrent={this.state.currentConcurrent} 
                    accessList={this.state.accessList} 

                    moduleStatus={this.state.moduleStatus} 
                    loggerStatus={this.state.loggerStatus} 
                    debuggerStatus={this.state.debuggerStatus} 
                    />
               // --------------------------------
                // DATA
                // --------------------------------
                case "PageCampaign":
                    return <PageCampaign accessList={this.state.accessList} />
                case "PageLeads":
                    return <PageLeads accessList={this.state.accessList} />
                case "PageData":
                    return <PageData accessList={this.state.accessList} />
                // --------------------------------
                // REPORT
                // --------------------------------
                case "RptCallHistory":
                    return <ReportCallHistory accessList={this.state.accessList} />
                case "RptCallResult":
                    return <RptCallResult accessList={this.state.accessList} />
                case "RptDataSummary":
                    return <RptDataSummary accessList={this.state.accessList} />
                case "RptIvrLog":
                    return <RptIvrLog accessList={this.state.accessList} />
                // --------------------------------
                // DIALER MANAGEMENT
                // --------------------------------
                case "PageCompany":
                    return <PageCompany accessList={this.state.accessList} />
                case "PageResult":
                    return <PageResult accessList={this.state.accessList} />  
                case "PageDialer":
                    return <PageDialer accessList={this.state.accessList} />  
                case "PageHoliday":
                    return <PageHoliday accessList={this.state.accessList} />  
                // --------------------------------
                // CALL MANAGEMENT
                // --------------------------------
                case "PageAGI":
                    return <PageAGI accessList={this.state.accessList} />
                case "PageVoiceprompt":
                    return <PageVoiceprompt accessList={this.state.accessList} />
                case "PageCallRoute":
                    return <PageCallRoute accessList={this.state.accessList} />
                case "PageTrunks":
                    return <PageTrunks accessList={this.state.accessList} />
                case "PageQueue":
                    return <PageACD accessList={this.state.accessList} />
                case "PageIvrMenu":
                    return <PageIvrMenu accessList={this.state.accessList} />
                case "PageIvrResponse":
                    return <PageIvrResponse accessList={this.state.accessList} />
                // --------------------------------
                // ACCESS MANAGEMENT
                // --------------------------------
                case "PageAPI":
                    return <PageAPI accessList={this.state.accessList} />  
                case "PageUsers":
                    return <PageUsers accessList={this.state.accessList} />
                case "PageRole":
                    return <PageRole accessList={this.state.accessList} />
                case "PageMatrix":
                    return <PageMatrix accessList={this.state.accessList} />
                // --------------------------------
                // SYSTEM MANAGEMENT
                // --------------------------------
                case "PageInformation":
                    return <PageInformation accessList={this.state.accessList} />
                case "PageSystem":
                    return <PageSystem accessList={this.state.accessList} />
                case "PageModule":
                    return <PageModule accessList={this.state.accessList} />
                case "PageAutotext":
                    return <PageAutotext accessList={this.state.accessList} funcNavigatePage={this.handleNavigatePages} />
                // --------------------------------
                // SYSTEM MAINTENANCE
                // --------------------------------
                case "PageLogAdmin":
                    return <PageLogAdmin accessList={this.state.accessList} />
                case "PageLogData":
                    return <PageLogData accessList={this.state.accessList} />
                // --------------------------------
                // MY ACCOUNT
                // --------------------------------
                case "PageAccount":
                    return <MyAccount />
                // --------------------------------
                case "":
                    return null;
                default:
                    return <Page404 />
            }
        }
        return (
            <div className='App'>
                <Header isLogged={this.state.isLoggedIn} funcLoggedOut={this.handleUpdateLoggedOut} funcNavigatePage={this.handleNavigatePages}/>
                {this.state.isLoggedIn?
                Halaman()
                :
                <WidgetLogin hostname={this.state.hostname} port={this.state.port} socketConnected={this.state.socketConnected} funcUpdateAccess={this.handleUpdateAccess} funcUpdatePage={this.handlePreloadPage} funcUpdateLoggedIn={this.handleUpdateLoggedIn} />
                }
                {this.state.showWidgetSocket?
                <WidgetConnection closeComponent={this.handleWidgetSocketClose} header={'Warning'} title={'Server Unreachable'} type={'error'} message={"Cannot connect to server. Please check your connection to the server !"}
                isButtonOption={true} labelButtonTrue={'Reconnect'} optionButtonTrue={this.handleReloadPage} />
                :null}
            </div>
        )
    }
}

export default Main;